export default class FormResponsesService {
  constructor(http) {
    this.http = http;
  }

  // async findAllFormResponses(conditions = {}) {
  //   const queryParams = Object.entries(conditions)
  //     .map(
  //       ([key, value]) =>
  //         `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
  //     )
  //     .join("&");
  //   return this.http.fetch(
  //     `/api/formresponses/readall?${queryParams}`,
  //     {
  //       method: "GET",
  //     }
  //   );
  // }

  async getFormResponsesByStudent(conditions) {
    const queryParams = Object.entries(conditions)
      .map(
        ([key, value]) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      )
      .join("&");
    return this.http.fetch(
      `/api/formresponses/readallbystudent?${queryParams}`,
      {
        method: "GET",
      }
    );
  }

  async createOrUpdateFormResponsesBulk(dataArray) {
    return this.http.fetch(`/api/formresponses/createorupdatebulk`, {
      method: "POST",
      body: JSON.stringify(dataArray),
    });
  }
}
